import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';

//import RadioGroup from '@material-ui/core/RadioGroup';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setRecordData } from '../../core/actions';
import Checkbox from '../../core/controls/components/checkbox.js';
import Dropdown from '../../core/controls/components/dropdown';
import RadioGroup from '../../core/controls/components/radiogroup';
import TextBox from '../../core/controls/components/textbox.js';
import { createRequest, requestApi as requestApiNew } from '../../core/controls/helpers/rest.js';
import FormHeader from '../../core/modules/form/cformheader';
import { requestApi } from '../../core/modules/form/utilities';
import Grid from '../../core/modules/Grid/cgrid';
import historygrid from '../../json/common/attachments/attachmenthistory';
import { getEnvVariable } from '../environmentalList';
import S3Upload from '../Uploads/S3Upload.js';
const _ = require('lodash');


const attachtypeitems = [{ "Name": "Upload Digital Document", 'Id': 'U' }, { 'Name': "Physical Paper Document", 'Id': 'P' }]

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const dropdownProps = {
    transformProps: {
        label: 'Name',
        value: 'Id'
    },
}

class ExtendFileAttachments extends Component {
    constructor(props) {
        super(props)
        this.state = {
            getallattachementtypes: [], AttachmentTypeId: '', notes: '', AttachmentType: 'U', externallink: '', downloadContent: null,
            downloadName: null, ContentStr: null, ContentType: null, FileName: null, attachedfiles: [], firstIterate: true, tabvalue: 0,
            recordid: null, includeremovedfiles: [], IsViewable: 'N', createdBy: this.props.dataItem && this.props.dataItem != undefined ?
                this.props.dataItem.CreatedBy : '',
            edit: this.props.edit, //getstatusattachmenttypes: []
        }
        if (this.props.updateAttachment) {
            this.attachmentComponentsArray = { ...historygrid };
            this.historygridjson = this.attachmentComponentsArray.options
        }
    }

    componentDidMount() {
        const read = [
            {
                url: this.props && this.props.dataItem ? getEnvVariable('AdminConfig') + `` + `/api/SitePermitTypeAttachments/SitePermitTypeAttachmentsTypes/${this.props.match.params.routeid}`
                    : getEnvVariable('AdminConfig') + `` + `/api/SitePermitTypeAttachments/SitePermitTypeAttachmentsTypes/${this.props.match.params.routeid}/${this.props.match.params.routeid1}`,
                type: 'get'

            }, {
                url: getEnvVariable('AdminConfig') + `/api/SitePermitTypesStatus/${this.props.match.params.routeid}/All`,
                type: 'get'
            }
        ]
        Promise.all(read.map(each => requestApiNew(createRequest(each, null, null)))).then(res => {
            const [getallattachementtypes, getstatus = []] = res;
            if (getstatus && getstatus.length > 0) {
                let statusid = this.props.initialloadextrainfo.results["APPLICATION_STATUS"]
                let id = _.find(getstatus, ['ApplicationStatusId', Number(statusid)]).Id
                const getstatusattachements = {
                    get: {
                        url: getEnvVariable('AdminConfig') + `` + `/api/SitePermitTypeAttachments/${this.props.match.params.routeid}/${id}/GetAllAttachments`
                    }
                }
                requestApi(getstatusattachements).then(getstatusattachmenttypes => {
                    let temp = getallattachementtypes && getallattachementtypes.length > 0 && getallattachementtypes.map(menu => {
                        let item = _.find(getstatusattachmenttypes, { 'AttachmentTypeId': menu.Id })
                        if (item && ((this.props.accessPermissions.portal == "I" && item.IsMandatory == "Y") ||
                            (this.props.accessPermissions.portal == "E" && item.IsExternalMandatory == "Y"))) {
                            return { Id: menu.Id, Name: menu.Name + ' (*Required*) ' }
                        }
                        else {
                            return menu
                        }
                    })
                    this.setState({ getallattachementtypes: temp })
                })
            }

        })
    }

    componentDidUpdate(prevState, prevProps) {
        const { recordid } = this.state
        if (prevProps.dataItem != this.props.dataItem) {
            if ((this.props.passresults) && (recordid != this.props.passresults.Id)) {
                this.setState({
                    recordid: this.props.dataItem.Id,
                    attachedfiles: this.props.passresults.AttachmentDetails,
                    //    includeremovedfiles: this.props.passresults.AttachmentDetails,
                    AttachmentType: this.props.passresults.AttachmentDetails.length > 0 ? 'U' : 'P',
                    notes: this.props.passresults.Notes,
                    AttachmentTypeId: this.props.passresults.AttachmentTypeId,
                }, () => this.getResult())
            }
        }
    }


    getResult = () => {
        let attachment = {}
        attachment.AttachmentTypeId = this.state.AttachmentTypeId;
        attachment.Notes = this.state.notes;
        attachment.IsViewable = this.state.IsViewable
        attachment.AttachmentType = this.state.AttachmentType || 'P'
        this.props.getallresultsInfo(attachment)
    }

    RemoveImage = (event) => {
        var e = {
            target: {
                name: event.target.name,
                value: ""
            }
        }
        this.props.handleFieldChange(e)
    }


    handleDelete = (newattachedfile, allfile) => {
        this.setState({ attachedfiles: newattachedfile, includeremovedfiles: allfile }, () => this.getResult())
    }

    handleFieldChange = name => event => {
        this.setState({ [name]: event.target.value }, () => this.getResult());
    }

    handleCheckBox = (event) => {
        this.setState({ IsViewable: event.target.value == "false" ? "Y" : "N" }, () => this.getResult());
    }

    handleChange = (event, newValue) => {
        this.setState({ tabvalue: newValue })
    }

    handleEdit = () => {
        this.setState({ edit: true })
    }

    render() {
        const { passresults, updateAttachment, editformat, classes, archiveParentId, docmissing, urlmissing, urlhelpertext, noteshelpertext, lengthhelpertext, notesinvalidhelpertext, typemissing, dataItem } = this.props
        const { AttachmentType, externallink, attachedfiles, AttachmentTypeId, notes, getallattachementtypes, getstatusattachmenttypes, tabvalue } = this.state;
        let externallock = this.props.initialloadextrainfo && this.props.initialloadextrainfo.results && this.props.initialloadextrainfo.results["EXTERNAL_LOCK"]
        let approvedflag = this.props.initialloadextrainfo && this.props.initialloadextrainfo.results && this.props.initialloadextrainfo.results["APPROVED_FLAG"]
        let savebuttondisplay = approvedflag == "Y" ? false : this.props.accessPermissions.portal == 'E' && ((this.props.dataItem && this.props.dataItem.PortalFlag == "I") || externallock == 'Y') ? false : true
        let roleaccess = this.props.accessPermissions && this.props.accessPermissions.moduleDistrictAccess && this.props.accessPermissions.moduleDistrictAccess ? Object.values(this.props.accessPermissions.moduleDistrictAccess).includes('Add') ? 'CanAdd' : Object.values(this.props.accessPermissions.moduleDistrictAccess).includes('Update') ? 'CanEdit' : Object.values(this.props.accessPermissions.moduleDistrictAccess).includes('Read') ? 'CanRead' : 'CanAdd' : 'CanAdd'
        let portal = this.props.accessPermissions ? this.props.accessPermissions.portal : null
        let canAdd = (!roleaccess || !portal) ? true : portal == "I" && roleaccess == "CanAdd" ? true : (portal == "E") ? true : false
        let canEdit = (!roleaccess || !portal) ? true : portal == "I" && roleaccess == "CanEdit" ? true : (portal == "E") ? true : false
        let canRead = (!roleaccess || !portal) ? true : portal == "I" && roleaccess == "CanRead" ? true : (portal == "E") ? true : false
        return (
            <div>
                {this.props.updateAttachment && <AppBar position="static" color="white">
                    <Tabs
                        value={tabvalue}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="on"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab label="View/Edit Attachment" {...a11yProps(0)} />
                        <Tab label="Attachment History" {...a11yProps(1)} />

                    </Tabs>
                </AppBar>}
                <TabPanel value={tabvalue} index={0}>
                    {this.props.updateAttachment && <FormHeader className="row" savebutton={this.state.edit ? (canAdd || canEdit) ? savebuttondisplay : false : false}
                        editbutton={!this.state.edit ? (canAdd || canEdit) ? savebuttondisplay : false : false} handleEdit={this.handleEdit} handleSave={this.props.handleSave} designprops={true} hasclearfix={true} />}
                    {!this.props.updateAttachment && <Dropdown
                        label='Attachment Type'
                        className="col-sm-8"
                        value={!passresults ? AttachmentTypeId : passresults.AttachmentTypeId}
                        required={true}
                        error={typemissing !== '' ? true : false}
                        helperText={typemissing !== '' ? typemissing : ''}
                        items={getallattachementtypes || []}
                        extraProps={dropdownProps}
                        handleFieldValue={this.handleFieldChange('AttachmentTypeId')}
                    />
                    }
                    {this.props.updateAttachment && <div>
                        <Typography variant="caption" className="fw-bold">
                            Attachment Type
                        </Typography>
                        {passresults && passresults.AttachmentTypeId && getallattachementtypes && getallattachementtypes.map(menu => {
                            if (menu.Id == passresults.AttachmentTypeId) {
                                return <Typography variant={'body2'} color={'textPrimary'} display="block" className="text-secondary eps-content-wrap">
                                    {menu.Name.replace(' (*Required*)', '')}
                                </Typography>
                            }
                            return null
                        })
                        } </div>}
                    {this.props.updateAttachment && !this.state.edit ? <div><Typography variant="caption" className="fw-bold">
                        Notes
                    </Typography>
                        <Typography variant={'body2'} color={'textPrimary'} display="block" className="text-secondary eps-content-wrap">
                            {notes}
                        </Typography></div> :
                        <TextBox
                            label="Notes"
                            value={notes}
                            handleFieldValue={this.handleFieldChange('notes')}
                            multiline={true}
                            rowsMax='4'
                            rows={4}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            error={(notesinvalidhelpertext || noteshelpertext || lengthhelpertext) !== '' ? true : false}
                            helperText={notesinvalidhelpertext || noteshelpertext || lengthhelpertext}
                        />
                    }
                    {this.props.updateAttachment && !this.state.edit ? <div><Typography variant="caption" className="fw-bold">
                        Selected Document Type
                    </Typography>
                        <Typography variant={'body2'} color={'textPrimary'} display="block" className="text-secondary eps-content-wrap">
                            {AttachmentType == 'U' ? 'Upload Digital Document' : (AttachmentType == 'L' ? 'External Link' : 'Physical Paper Document')}
                        </Typography></div> : <RadioGroup
                        value={AttachmentType || 'U'}
                        handleFieldValue={this.handleFieldChange('AttachmentType')}
                        items={attachtypeitems}
                        extraProps={dropdownProps}
                        label={'Select Document Type'}
                    />}

                    {this.state.AttachmentType === "U" && <div className={"row col-sm-12"} >
                        <S3Upload {...this.props} filetype={"Attachments"} canSave={this.props.canSave}
                            attachmentDetailsCallBack={this.props.attachmentDetailsCallBack}
                            onAttachmentAddCallBack={this.props.onAttachmentAddCallBack} />
                        {docmissing && <div style={{ color: docmissing ? "#F44336" : "" }}>
                            <Typography variant="caption" display="block" gutterBottom>
                                Please upload atleast one document
                            </Typography>

                        </div>}
                    </div>}
                    {getEnvVariable('AccessPortal') === 'I' && (!this.props.updateAttachment || this.state.edit) && <div>

                        {!(this.props && this.props.dataItem && this.props.dataItem.PortalFlag == "E") &&
                            <Checkbox
                                checked={this.state.IsViewable == 'Y' ? true : false}
                                handleFieldValue={(e) => this.handleCheckBox(e)}
                                value={this.state.IsViewable}
                                disabled={this.props && this.props.dataItem && this.props.dataItem.PortalFlag == "E" ? true : false}
                                label="Can be Viewed by Applicant"
                            />
                        }
                    </div>}
                    {getEnvVariable('AccessPortal') === 'I' && (this.props.updateAttachment && !this.state.edit) && <div>
                        <div><Typography variant="caption" className="fw-bold">
                            Can be Viewed by Applicant
                        </Typography>
                            <Typography variant={'body2'} color={'textPrimary'} display="block" className="text-secondary eps-content-wrap">
                                {this.state.IsViewable == 'N' ? 'No' : 'Yes'}
                            </Typography></div>
                    </div>}

                    {passresults && <div className="row pt-3">
                        <div className="col-12"> <div className="col-sm-6 float-md-right" style={{ color: '#6C757D', fontSize: '12px' }}><span style={{ color: '#6C757D', fontSize: '12px' }}>Created By : </span> {passresults.CreatedByName}</div>
                            <div className="col-sm-6 " style={{ color: '#6C757D', fontSize: '12px' }}><span style={{ color: '#6C757D', fontSize: '12px' }}>Created On : </span> {moment(passresults.CreatedOn).format('MM/DD/YYYY hh:mm:ss A')}</div>
                        </div>
                        <div className="col-12">
                            {passresults.UpdatedBy === null ? ('') : (<div className="col-sm-6 float-md-right" style={{ color: '#6C757D', fontSize: '12px' }}><span style={{ color: '#6C757D', fontSize: '12px' }}>Updated By : </span> {passresults.UpdatedByName}</div>)}
                            {passresults.UpdatedOn === null ? ('') : (<div className="col-sm-6" style={{ color: '#6C757D', fontSize: '12px' }}><span style={{ color: '#6C757D', fontSize: '12px' }}>Updated On : </span> {moment(passresults.UpdatedOn).format('MM/DD/YYYY hh:mm:ss A')}</div>)}
                        </div>
                    </div>}

                </TabPanel >
                <TabPanel value={tabvalue} index={1}>
                    <Grid options={this.historygridjson} dataItem={dataItem} />
                </TabPanel>
            </div >
        )
    }
}

const mapProps = (state) => {
    return state
}

const mapActions = dispatch => {
    return bindActionCreators({ setRecordData }, dispatch);
}

ExtendFileAttachments = connect(mapProps, mapActions)(ExtendFileAttachments)
export default withRouter(ExtendFileAttachments)
